export function makeElement(type) {
    return document.createElement(type);
}

export function insertElement(element) {
    document.body.append(element);
}
